import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import PatientUserRelations from './PatientUserRelations';

loadDOMComponent({
	selector: 'react-patient-user-relations',
	callback: ({ container }) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<AppContextProvider>
				<PatientUserRelations userId={userId} />
			</AppContextProvider>,
			container,
		);
	},
});
